export default __webpack_public_path__ + "static/media/PositivH.9d711684.mp4";